module.exports = __webpack_public_path__ + "static/img/rys6.246a324.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rys6.jpg
// module id = 0+Sh
// module chunks = 1